import { TiptapContentNode } from '../../tiptapTypes';

/**
 * Recurses through the entire Tiptap content and reduces it to a single value.
 * Executes the reducer function on each node in the content.
 */
export const reduceTiptapContent = <T>(
    tiptapNode: TiptapContentNode,
    reducer: (acc: T, node: TiptapContentNode, ancestors: TiptapContentNode[]) => T,
    initialVal: T,
    ancestors: TiptapContentNode[] = [],
): T => {
    const newVal = reducer(initialVal, tiptapNode, ancestors);

    if (!tiptapNode.content) return newVal;

    return tiptapNode.content.reduce(
        (acc, currentTiptapNode) => reduceTiptapContent(currentTiptapNode, reducer, acc, [tiptapNode, ...ancestors]),
        newVal,
    );
};
